import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_17bd8523 from 'nuxt_plugin_plugin_17bd8523' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_37b7506a from 'nuxt_plugin_plugin_37b7506a' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_libplugin6768ccaa_6aa760cc from 'nuxt_plugin_libplugin6768ccaa_6aa760cc' // Source: ./lib.plugin.6768ccaa.js (mode: 'client')
import nuxt_plugin_pluginutils_69104aa2 from 'nuxt_plugin_pluginutils_69104aa2' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_1c28b76d from 'nuxt_plugin_pluginrouting_1c28b76d' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_f3cf99bc from 'nuxt_plugin_pluginmain_f3cf99bc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_workbox_513c3795 from 'nuxt_plugin_workbox_513c3795' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_164319a8 from 'nuxt_plugin_metaplugin_164319a8' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_1aeabf1c from 'nuxt_plugin_iconplugin_1aeabf1c' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_sentry_e47869fc from 'nuxt_plugin_sentry_e47869fc' // Source: ../plugins/sentry.js (mode: 'client')
import nuxt_plugin_domainlocale_1efad70a from 'nuxt_plugin_domainlocale_1efad70a' // Source: ../plugins/domain-locale.js (mode: 'client')
import nuxt_plugin_authinit_05eaa390 from 'nuxt_plugin_authinit_05eaa390' // Source: ../plugins/auth-init.js (mode: 'client')
import nuxt_plugin_apexcharts_475acaea from 'nuxt_plugin_apexcharts_475acaea' // Source: ../plugins/apexcharts.js (mode: 'client')
import nuxt_plugin_dropzone_68b51bc6 from 'nuxt_plugin_dropzone_68b51bc6' // Source: ../plugins/dropzone.js (mode: 'client')
import nuxt_plugin_smartCaptcha_4c20c1b0 from 'nuxt_plugin_smartCaptcha_4c20c1b0' // Source: ../plugins/smartCaptcha.js (mode: 'client')
import nuxt_plugin_fuse_6e95fa80 from 'nuxt_plugin_fuse_6e95fa80' // Source: ../plugins/fuse.js (mode: 'all')
import nuxt_plugin_calendarHelpers_08a95526 from 'nuxt_plugin_calendarHelpers_08a95526' // Source: ../plugins/calendarHelpers.js (mode: 'all')
import nuxt_plugin_phoneFormatter_8a778e76 from 'nuxt_plugin_phoneFormatter_8a778e76' // Source: ../plugins/phoneFormatter.js (mode: 'all')
import nuxt_plugin_currency_37da79e0 from 'nuxt_plugin_currency_37da79e0' // Source: ../plugins/currency.js (mode: 'all')
import nuxt_plugin_validators_68c67180 from 'nuxt_plugin_validators_68c67180' // Source: ../plugins/validators.js (mode: 'all')
import nuxt_plugin_dadata_0ce3783a from 'nuxt_plugin_dadata_0ce3783a' // Source: ../plugins/dadata.js (mode: 'all')
import nuxt_plugin_emailValidator_7479aa6b from 'nuxt_plugin_emailValidator_7479aa6b' // Source: ../plugins/emailValidator.js (mode: 'all')
import nuxt_plugin_gosNumberFormatter_0c14910b from 'nuxt_plugin_gosNumberFormatter_0c14910b' // Source: ../plugins/gosNumberFormatter.js (mode: 'all')
import nuxt_plugin_vmask_3c04b27e from 'nuxt_plugin_vmask_3c04b27e' // Source: ../plugins/v-mask.js (mode: 'client')
import nuxt_plugin_vreveal_69c1293d from 'nuxt_plugin_vreveal_69c1293d' // Source: ../plugins/v-reveal.js (mode: 'client')
import nuxt_plugin_swnavigatorclient_431c0d82 from 'nuxt_plugin_swnavigatorclient_431c0d82' // Source: ../plugins/sw-navigator.client.js (mode: 'client')
import nuxt_plugin_auth_01f2bd52 from 'nuxt_plugin_auth_01f2bd52' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_meta_6a45a99d from 'nuxt_plugin_meta_6a45a99d' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Блиц-Запись - программа для учета клиентов и онлайн-записи","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"hid":"description","name":"description","content":"Программа для учета клиентов и онлайн-записи для автосервисов, автомоек, шиномонтажа и детейлинга. Календарь загрузки постов, напоминания клиентам, аналитика. 14 дней бесплатно."},{"hid":"robots","name":"robots","content":"index, follow, max-image-preview:large"},{"hid":"og:url","property":"og:url","content":"\u002F"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"Блиц-Запись"},{"hid":"og:title","property":"og:title","content":"Блиц-Запись - программа для учета клиентов и онлайн-записи"},{"hid":"og:description","property":"og:description","content":"Программа для учета клиентов и онлайн-записи для автосервисов, автомоек, шиномонтажа и детейлинга. Календарь загрузки постов, напоминания клиентам, аналитика. 14 дней бесплатно."},{"hid":"og:image","property":"og:image","content":"\u002Fog-cover.png"},{"hid":"og:image:width","property":"og:image:width","content":"1666"},{"hid":"og:image:height","property":"og:image:height","content":"841"},{"hid":"og:locale","property":"og:locale","content":"ru_RU"},{"hid":"twitter:card","name":"twitter:card","content":"summary_large_image"},{"hid":"twitter:title","name":"twitter:title","content":"Блиц-Запись - программа для учета клиентов и онлайн-записи"},{"hid":"twitter:description","name":"twitter:description","content":"Программа для учета клиентов и онлайн-записи для автосервисов, автомоек, шиномонтажа и детейлинга. Календарь загрузки постов, напоминания клиентам, аналитика. 14 дней бесплатно."},{"hid":"twitter:image","name":"twitter:image","content":"\u002Fog-cover.png"},{"name":"format-detection","content":"telephone=no"},{"hid":"charset","charset":"utf-8"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-capable","name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Блиц-Запись.рф"},{"hid":"theme-color","name":"theme-color","content":"#1B7984"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"hid":"shortcut-icon","rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.8816fc.png"},{"hid":"apple-touch-icon","rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.8816fc.png","sizes":"512x512"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphonese_640x1136.8816fc.png","media":"(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphonese"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphone6_50x1334.8816fc.png","media":"(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphone6"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphoneplus_1080x1920.8816fc.png","media":"(device-width: 621px) and (device-height: 1104px) and (-webkit-device-pixel-ratio: 3)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphoneplus"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphonex_1125x2436.8816fc.png","media":"(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphonex"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphonexr_828x1792.8816fc.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphonexr"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_iphonexsmax_1242x2688.8816fc.png","media":"(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-iphonexsmax"},{"href":"\u002F_nuxt\u002Ficons\u002Fsplash_ipad_1536x2048.8816fc.png","media":"(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-ipad"},{"media":"(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-ipadpro1"},{"media":"(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-ipadpro2"},{"media":"(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2)","rel":"apple-touch-startup-image","hid":"apple-touch-startup-image-ipadpro3"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.01129643.json","hid":"manifest"}],"script":[{"innerHTML":"var KkmServerAddIn = {}","type":"text\u002Fjavascript"},{"hid":"ld-organization","type":"application\u002Fld+json","innerHTML":"{\"@context\":\"https:\u002F\u002Fschema.org\",\"@type\":\"Organization\",\"name\":\"Блиц-Запись\",\"url\":\"\u002F\",\"logo\":\"\u002Ficon.png\",\"email\":\"blitz@forus.ru\",\"address\":{\"@type\":\"PostalAddress\",\"addressLocality\":\"Иркутск\",\"streetAddress\":\"ул. Партизанская, 49\",\"addressCountry\":\"RU\"},\"sameAs\":[\"https:\u002F\u002Fvk.com\u002Fblitzzapis\",\"https:\u002F\u002Ft.me\u002Fblitz_booking\"]}"},{"hid":"ld-software-application","type":"application\u002Fld+json","innerHTML":"{\"@context\":\"https:\u002F\u002Fschema.org\",\"@type\":\"SoftwareApplication\",\"name\":\"Блиц-Запись\",\"url\":\"\u002F\",\"description\":\"Программа для учета клиентов и онлайн-записи для автосервисов, автомоек, шиномонтажа и детейлинга. Календарь загрузки постов, напоминания клиентам, аналитика. 14 дней бесплатно.\",\"applicationCategory\":\"BusinessApplication\",\"operatingSystem\":\"Web, Android, iOS\",\"screenshot\":\"\u002Fog-cover.png\",\"featureList\":[\"Онлайн-запись клиентов\",\"Календарь загрузки постов и рабочих мест\",\"Клиентская база и история визитов\",\"Автоматические напоминания клиентам\",\"Аналитика загрузки и выручки\",\"Конструктор услуг\"],\"offers\":{\"@type\":\"AggregateOffer\",\"priceCurrency\":\"RUB\",\"lowPrice\":\"1500\",\"highPrice\":\"2500\",\"offerCount\":\"4\",\"availability\":\"https:\u002F\u002Fschema.org\u002FInStock\"},\"publisher\":{\"@type\":\"Organization\",\"name\":\"НПФ Форус\"}}"}],"__dangerouslyDisableSanitizers":["script"],"style":[],"htmlAttrs":{"lang":"ru"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_17bd8523 === 'function') {
    await nuxt_plugin_plugin_17bd8523(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_37b7506a === 'function') {
    await nuxt_plugin_plugin_37b7506a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_libplugin6768ccaa_6aa760cc === 'function') {
    await nuxt_plugin_libplugin6768ccaa_6aa760cc(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_69104aa2 === 'function') {
    await nuxt_plugin_pluginutils_69104aa2(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1c28b76d === 'function') {
    await nuxt_plugin_pluginrouting_1c28b76d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_f3cf99bc === 'function') {
    await nuxt_plugin_pluginmain_f3cf99bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_513c3795 === 'function') {
    await nuxt_plugin_workbox_513c3795(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_164319a8 === 'function') {
    await nuxt_plugin_metaplugin_164319a8(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_1aeabf1c === 'function') {
    await nuxt_plugin_iconplugin_1aeabf1c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_e47869fc === 'function') {
    await nuxt_plugin_sentry_e47869fc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_domainlocale_1efad70a === 'function') {
    await nuxt_plugin_domainlocale_1efad70a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_authinit_05eaa390 === 'function') {
    await nuxt_plugin_authinit_05eaa390(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apexcharts_475acaea === 'function') {
    await nuxt_plugin_apexcharts_475acaea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_dropzone_68b51bc6 === 'function') {
    await nuxt_plugin_dropzone_68b51bc6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_smartCaptcha_4c20c1b0 === 'function') {
    await nuxt_plugin_smartCaptcha_4c20c1b0(app.context, inject)
  }

  if (typeof nuxt_plugin_fuse_6e95fa80 === 'function') {
    await nuxt_plugin_fuse_6e95fa80(app.context, inject)
  }

  if (typeof nuxt_plugin_calendarHelpers_08a95526 === 'function') {
    await nuxt_plugin_calendarHelpers_08a95526(app.context, inject)
  }

  if (typeof nuxt_plugin_phoneFormatter_8a778e76 === 'function') {
    await nuxt_plugin_phoneFormatter_8a778e76(app.context, inject)
  }

  if (typeof nuxt_plugin_currency_37da79e0 === 'function') {
    await nuxt_plugin_currency_37da79e0(app.context, inject)
  }

  if (typeof nuxt_plugin_validators_68c67180 === 'function') {
    await nuxt_plugin_validators_68c67180(app.context, inject)
  }

  if (typeof nuxt_plugin_dadata_0ce3783a === 'function') {
    await nuxt_plugin_dadata_0ce3783a(app.context, inject)
  }

  if (typeof nuxt_plugin_emailValidator_7479aa6b === 'function') {
    await nuxt_plugin_emailValidator_7479aa6b(app.context, inject)
  }

  if (typeof nuxt_plugin_gosNumberFormatter_0c14910b === 'function') {
    await nuxt_plugin_gosNumberFormatter_0c14910b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vmask_3c04b27e === 'function') {
    await nuxt_plugin_vmask_3c04b27e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vreveal_69c1293d === 'function') {
    await nuxt_plugin_vreveal_69c1293d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swnavigatorclient_431c0d82 === 'function') {
    await nuxt_plugin_swnavigatorclient_431c0d82(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_01f2bd52 === 'function') {
    await nuxt_plugin_auth_01f2bd52(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_6a45a99d === 'function') {
    await nuxt_plugin_meta_6a45a99d(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
